import type { CategorySlug } from '@features/category-navigation';

const STORAGE_KEYS = {
  PREFERRED_CATEGORY: 'todays-news-preferred-category',
  THEME_PREFERENCE: 'todays-news-theme',
} as const;

export const storage = {
  getPreferredCategory(): CategorySlug {
    try {
      const stored = localStorage.getItem(STORAGE_KEYS.PREFERRED_CATEGORY);
      if (stored) {
        return stored;
      }
    } catch (error) {
      console.warn('Failed to read preferred category from localStorage:', error);
    }

    return (import.meta.env.VITE_DEFAULT_CATEGORY as CategorySlug) || 'uk';
  },

  setPreferredCategory(category: CategorySlug): void {
    try {
      localStorage.setItem(STORAGE_KEYS.PREFERRED_CATEGORY, category);
    } catch (error) {
      console.warn('Failed to save preferred category to localStorage:', error);
    }
  },

  getThemePreference(): 'light' | 'dark' | 'auto' {
    try {
      const stored = localStorage.getItem(STORAGE_KEYS.THEME_PREFERENCE);
      if (stored && ['light', 'dark', 'auto'].includes(stored)) {
        return stored as 'light' | 'dark' | 'auto';
      }
    } catch (error) {
      console.warn('Failed to read theme preference from localStorage:', error);
    }

    return 'auto';
  },

  setThemePreference(theme: 'light' | 'dark' | 'auto'): void {
    try {
      localStorage.setItem(STORAGE_KEYS.THEME_PREFERENCE, theme);
    } catch (error) {
      console.warn('Failed to save theme preference to localStorage:', error);
    }
  },

  clearAll(): void {
    try {
      Object.values(STORAGE_KEYS).forEach(key => {
        localStorage.removeItem(key);
      });
    } catch (error) {
      console.warn('Failed to clear localStorage:', error);
    }
  },
};
